/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ArrowUpIcon = /*#__PURE__*/ createSvgIcon(
  'ArrowUpIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.25 6.875L5.58 10.546a.721.721 0 01-.527.225.763.763 0 01-.76-.76c0-.202.075-.378.225-.528l4.96-4.954a.723.723 0 01.526-.216c.1 0 .194.017.282.052a.69.69 0 01.236.156l4.958 4.958c.153.153.23.327.23.521a.733.733 0 01-.22.52.766.766 0 01-.545.23.71.71 0 01-.527-.23L10.75 6.876v8.375c0 .213-.071.39-.214.535a.72.72 0 01-.531.215.734.734 0 01-.536-.215.72.72 0 01-.219-.535V6.875z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ArrowUpIcon;
